import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_sentryserver_a913e632 from 'nuxt_plugin_sentryserver_a913e632'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_45bc9b5f from 'nuxt_plugin_sentryclient_45bc9b5f'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_appplugin_08505622 from 'nuxt_plugin_appplugin_08505622'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_ac851f80 from 'nuxt_plugin_configplugin_ac851f80'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_pluginsplugina7b61e20_d4565fe0 from 'nuxt_plugin_pluginsplugina7b61e20_d4565fe0'; // Source: ./plugins.plugin.a7b61e20.js (mode: 'all')
import nuxt_plugin_pluginutils_47598f10 from 'nuxt_plugin_pluginutils_47598f10'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6b30f07a from 'nuxt_plugin_pluginrouting_6b30f07a'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1e75328c from 'nuxt_plugin_pluginmain_1e75328c'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7687cc6a from 'nuxt_plugin_cookieuniversalnuxt_7687cc6a'; // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_capiplugin_ab8ad7e0 from 'nuxt_plugin_capiplugin_ab8ad7e0'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_3588c699 from 'nuxt_plugin_errorpluginserver_3588c699'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_pluginserver_5420358e from 'nuxt_plugin_pluginserver_5420358e'; // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_703673b1 from 'nuxt_plugin_pluginclient_703673b1'; // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_portalvue_5fb12be0 from 'nuxt_plugin_portalvue_5fb12be0'; // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_components_50cb0b6b from 'nuxt_plugin_components_50cb0b6b'; // Source: ../plugins/components.js (mode: 'all')
import nuxt_plugin_eventbus_3db4fade from 'nuxt_plugin_eventbus_3db4fade'; // Source: ../plugins/eventbus.ts (mode: 'all')
import nuxt_plugin_centrifuge_5f671275 from 'nuxt_plugin_centrifuge_5f671275'; // Source: ../plugins/centrifuge.js (mode: 'all')
import nuxt_plugin_print_a4dc9cc0 from 'nuxt_plugin_print_a4dc9cc0'; // Source: ../plugins/print.js (mode: 'all')
import nuxt_plugin_export_ee03f9e6 from 'nuxt_plugin_export_ee03f9e6'; // Source: ../plugins/export.js (mode: 'all')
import nuxt_plugin_cookies_2c3cf8fe from 'nuxt_plugin_cookies_2c3cf8fe'; // Source: ../plugins/cookies.js (mode: 'all')
import nuxt_plugin_active_2825cb00 from 'nuxt_plugin_active_2825cb00'; // Source: ../plugins/auth/active.js (mode: 'all')
import nuxt_plugin_index_78cdc694 from 'nuxt_plugin_index_78cdc694'; // Source: ../plugins/auth/index.js (mode: 'all')
import nuxt_plugin_grants_d1d54de2 from 'nuxt_plugin_grants_d1d54de2'; // Source: ../plugins/auth/grants.js (mode: 'all')
import nuxt_plugin_features_5ff303ae from 'nuxt_plugin_features_5ff303ae'; // Source: ../plugins/auth/features.js (mode: 'all')
import nuxt_plugin_gates_5f7104c0 from 'nuxt_plugin_gates_5f7104c0'; // Source: ../plugins/auth/gates.js (mode: 'all')
import nuxt_plugin_date_3cd5b753 from 'nuxt_plugin_date_3cd5b753'; // Source: ../plugins/date.js (mode: 'all')
import nuxt_plugin_customDateFns_70ad6efe from 'nuxt_plugin_customDateFns_70ad6efe'; // Source: ../plugins/customDateFns.js (mode: 'all')
import nuxt_plugin_currency_37da79e0 from 'nuxt_plugin_currency_37da79e0'; // Source: ../plugins/currency.js (mode: 'all')
import nuxt_plugin_redirect_368ca365 from 'nuxt_plugin_redirect_368ca365'; // Source: ../plugins/redirect.js (mode: 'all')
import nuxt_plugin_panel_324d86e9 from 'nuxt_plugin_panel_324d86e9'; // Source: ../plugins/panel.js (mode: 'all')
import nuxt_plugin_dialog_80887e0e from 'nuxt_plugin_dialog_80887e0e'; // Source: ../plugins/dialog.js (mode: 'all')
import nuxt_plugin_modal_640f2cc0 from 'nuxt_plugin_modal_640f2cc0'; // Source: ../plugins/modal.js (mode: 'all')
import nuxt_plugin_mobile_d5f19142 from 'nuxt_plugin_mobile_d5f19142'; // Source: ../plugins/mobile.js (mode: 'all')
import nuxt_plugin_app_784ba9a8 from 'nuxt_plugin_app_784ba9a8'; // Source: ../plugins/app.js (mode: 'all')
import nuxt_plugin_holidays_af2b0874 from 'nuxt_plugin_holidays_af2b0874'; // Source: ../plugins/holidays.js (mode: 'all')
import nuxt_plugin_veevalidate_34294c84 from 'nuxt_plugin_veevalidate_34294c84'; // Source: ../plugins/packages/vee-validate.js (mode: 'all')
import nuxt_plugin_gtag_6f873798 from 'nuxt_plugin_gtag_6f873798'; // Source: ../plugins/packages/gtag.js (mode: 'all')
import nuxt_plugin_idle_82bf8412 from 'nuxt_plugin_idle_82bf8412'; // Source: ../plugins/packages/idle.js (mode: 'client')
import nuxt_plugin_shortkey_158185f0 from 'nuxt_plugin_shortkey_158185f0'; // Source: ../plugins/packages/shortkey.js (mode: 'client')
import nuxt_plugin_vcalendar_1e0c5476 from 'nuxt_plugin_vcalendar_1e0c5476'; // Source: ../plugins/packages/v-calendar.js (mode: 'client')
import nuxt_plugin_accounts_1a1f19e0 from 'nuxt_plugin_accounts_1a1f19e0'; // Source: ../plugins/auth/accounts.js (mode: 'client')
import nuxt_plugin_imperaviarticle_6a4a25e7 from 'nuxt_plugin_imperaviarticle_6a4a25e7'; // Source: ../plugins/packages/imperavi-article.js (mode: 'client')
import nuxt_plugin_redactor_69963c72 from 'nuxt_plugin_redactor_69963c72'; // Source: ../plugins/packages/redactor.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
          store.registerModule = registerModule;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": "Ovatu Manager",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, shrink-to-fit=no"
              }, {
                "name": "mobile-web-app-capable",
                "content": "yes"
              }, {
                "name": "apple-mobile-web-app-capable",
                "content": "yes"
              }, {
                "name": "msapplication-starturl",
                "content": "/"
              }, {
                "name": "apple-itunes-app",
                "content": "app-id=1589890786"
              }, {
                "hid": "description",
                "name": "description",
                "content": ""
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicon.ico"
              }, {
                "rel": "manifest",
                "href": "/manifest.json"
              }],
              "script": [{
                "src": "/helpscout.js",
                "body": true,
                "async": true
              }],
              "bodyAttrs": {
                "class": "antialiased font-sans text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-900"
              },
              "style": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 14;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 14:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(process.server && typeof nuxt_plugin_sentryserver_a913e632 === 'function')) {
            _context2.next = 20;
            break;
          }
          _context2.next = 20;
          return nuxt_plugin_sentryserver_a913e632(app.context, inject);
        case 20:
          if (!(process.client && typeof nuxt_plugin_sentryclient_45bc9b5f === 'function')) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return nuxt_plugin_sentryclient_45bc9b5f(app.context, inject);
        case 23:
          if (!(typeof nuxt_plugin_appplugin_08505622 === 'function')) {
            _context2.next = 26;
            break;
          }
          _context2.next = 26;
          return nuxt_plugin_appplugin_08505622(app.context, inject);
        case 26:
          if (!(typeof nuxt_plugin_configplugin_ac851f80 === 'function')) {
            _context2.next = 29;
            break;
          }
          _context2.next = 29;
          return nuxt_plugin_configplugin_ac851f80(app.context, inject);
        case 29:
          if (!(typeof nuxt_plugin_pluginsplugina7b61e20_d4565fe0 === 'function')) {
            _context2.next = 32;
            break;
          }
          _context2.next = 32;
          return nuxt_plugin_pluginsplugina7b61e20_d4565fe0(app.context, inject);
        case 32:
          if (!(typeof nuxt_plugin_pluginutils_47598f10 === 'function')) {
            _context2.next = 35;
            break;
          }
          _context2.next = 35;
          return nuxt_plugin_pluginutils_47598f10(app.context, inject);
        case 35:
          if (!(typeof nuxt_plugin_pluginrouting_6b30f07a === 'function')) {
            _context2.next = 38;
            break;
          }
          _context2.next = 38;
          return nuxt_plugin_pluginrouting_6b30f07a(app.context, inject);
        case 38:
          if (!(typeof nuxt_plugin_pluginmain_1e75328c === 'function')) {
            _context2.next = 41;
            break;
          }
          _context2.next = 41;
          return nuxt_plugin_pluginmain_1e75328c(app.context, inject);
        case 41:
          if (!(typeof nuxt_plugin_cookieuniversalnuxt_7687cc6a === 'function')) {
            _context2.next = 44;
            break;
          }
          _context2.next = 44;
          return nuxt_plugin_cookieuniversalnuxt_7687cc6a(app.context, inject);
        case 44:
          if (!(typeof nuxt_plugin_capiplugin_ab8ad7e0 === 'function')) {
            _context2.next = 47;
            break;
          }
          _context2.next = 47;
          return nuxt_plugin_capiplugin_ab8ad7e0(app.context, inject);
        case 47:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_3588c699 === 'function')) {
            _context2.next = 50;
            break;
          }
          _context2.next = 50;
          return nuxt_plugin_errorpluginserver_3588c699(app.context, inject);
        case 50:
          if (!(process.server && typeof nuxt_plugin_pluginserver_5420358e === 'function')) {
            _context2.next = 53;
            break;
          }
          _context2.next = 53;
          return nuxt_plugin_pluginserver_5420358e(app.context, inject);
        case 53:
          if (!(process.client && typeof nuxt_plugin_pluginclient_703673b1 === 'function')) {
            _context2.next = 56;
            break;
          }
          _context2.next = 56;
          return nuxt_plugin_pluginclient_703673b1(app.context, inject);
        case 56:
          if (!(typeof nuxt_plugin_portalvue_5fb12be0 === 'function')) {
            _context2.next = 59;
            break;
          }
          _context2.next = 59;
          return nuxt_plugin_portalvue_5fb12be0(app.context, inject);
        case 59:
          if (!(typeof nuxt_plugin_components_50cb0b6b === 'function')) {
            _context2.next = 62;
            break;
          }
          _context2.next = 62;
          return nuxt_plugin_components_50cb0b6b(app.context, inject);
        case 62:
          if (!(typeof nuxt_plugin_eventbus_3db4fade === 'function')) {
            _context2.next = 65;
            break;
          }
          _context2.next = 65;
          return nuxt_plugin_eventbus_3db4fade(app.context, inject);
        case 65:
          if (!(typeof nuxt_plugin_centrifuge_5f671275 === 'function')) {
            _context2.next = 68;
            break;
          }
          _context2.next = 68;
          return nuxt_plugin_centrifuge_5f671275(app.context, inject);
        case 68:
          if (!(typeof nuxt_plugin_print_a4dc9cc0 === 'function')) {
            _context2.next = 71;
            break;
          }
          _context2.next = 71;
          return nuxt_plugin_print_a4dc9cc0(app.context, inject);
        case 71:
          if (!(typeof nuxt_plugin_export_ee03f9e6 === 'function')) {
            _context2.next = 74;
            break;
          }
          _context2.next = 74;
          return nuxt_plugin_export_ee03f9e6(app.context, inject);
        case 74:
          if (!(typeof nuxt_plugin_cookies_2c3cf8fe === 'function')) {
            _context2.next = 77;
            break;
          }
          _context2.next = 77;
          return nuxt_plugin_cookies_2c3cf8fe(app.context, inject);
        case 77:
          if (!(typeof nuxt_plugin_active_2825cb00 === 'function')) {
            _context2.next = 80;
            break;
          }
          _context2.next = 80;
          return nuxt_plugin_active_2825cb00(app.context, inject);
        case 80:
          if (!(typeof nuxt_plugin_index_78cdc694 === 'function')) {
            _context2.next = 83;
            break;
          }
          _context2.next = 83;
          return nuxt_plugin_index_78cdc694(app.context, inject);
        case 83:
          if (!(typeof nuxt_plugin_grants_d1d54de2 === 'function')) {
            _context2.next = 86;
            break;
          }
          _context2.next = 86;
          return nuxt_plugin_grants_d1d54de2(app.context, inject);
        case 86:
          if (!(typeof nuxt_plugin_features_5ff303ae === 'function')) {
            _context2.next = 89;
            break;
          }
          _context2.next = 89;
          return nuxt_plugin_features_5ff303ae(app.context, inject);
        case 89:
          if (!(typeof nuxt_plugin_gates_5f7104c0 === 'function')) {
            _context2.next = 92;
            break;
          }
          _context2.next = 92;
          return nuxt_plugin_gates_5f7104c0(app.context, inject);
        case 92:
          if (!(typeof nuxt_plugin_date_3cd5b753 === 'function')) {
            _context2.next = 95;
            break;
          }
          _context2.next = 95;
          return nuxt_plugin_date_3cd5b753(app.context, inject);
        case 95:
          if (!(typeof nuxt_plugin_customDateFns_70ad6efe === 'function')) {
            _context2.next = 98;
            break;
          }
          _context2.next = 98;
          return nuxt_plugin_customDateFns_70ad6efe(app.context, inject);
        case 98:
          if (!(typeof nuxt_plugin_currency_37da79e0 === 'function')) {
            _context2.next = 101;
            break;
          }
          _context2.next = 101;
          return nuxt_plugin_currency_37da79e0(app.context, inject);
        case 101:
          if (!(typeof nuxt_plugin_redirect_368ca365 === 'function')) {
            _context2.next = 104;
            break;
          }
          _context2.next = 104;
          return nuxt_plugin_redirect_368ca365(app.context, inject);
        case 104:
          if (!(typeof nuxt_plugin_panel_324d86e9 === 'function')) {
            _context2.next = 107;
            break;
          }
          _context2.next = 107;
          return nuxt_plugin_panel_324d86e9(app.context, inject);
        case 107:
          if (!(typeof nuxt_plugin_dialog_80887e0e === 'function')) {
            _context2.next = 110;
            break;
          }
          _context2.next = 110;
          return nuxt_plugin_dialog_80887e0e(app.context, inject);
        case 110:
          if (!(typeof nuxt_plugin_modal_640f2cc0 === 'function')) {
            _context2.next = 113;
            break;
          }
          _context2.next = 113;
          return nuxt_plugin_modal_640f2cc0(app.context, inject);
        case 113:
          if (!(typeof nuxt_plugin_mobile_d5f19142 === 'function')) {
            _context2.next = 116;
            break;
          }
          _context2.next = 116;
          return nuxt_plugin_mobile_d5f19142(app.context, inject);
        case 116:
          if (!(typeof nuxt_plugin_app_784ba9a8 === 'function')) {
            _context2.next = 119;
            break;
          }
          _context2.next = 119;
          return nuxt_plugin_app_784ba9a8(app.context, inject);
        case 119:
          if (!(typeof nuxt_plugin_holidays_af2b0874 === 'function')) {
            _context2.next = 122;
            break;
          }
          _context2.next = 122;
          return nuxt_plugin_holidays_af2b0874(app.context, inject);
        case 122:
          if (!(typeof nuxt_plugin_veevalidate_34294c84 === 'function')) {
            _context2.next = 125;
            break;
          }
          _context2.next = 125;
          return nuxt_plugin_veevalidate_34294c84(app.context, inject);
        case 125:
          if (!(typeof nuxt_plugin_gtag_6f873798 === 'function')) {
            _context2.next = 128;
            break;
          }
          _context2.next = 128;
          return nuxt_plugin_gtag_6f873798(app.context, inject);
        case 128:
          if (!(process.client && typeof nuxt_plugin_idle_82bf8412 === 'function')) {
            _context2.next = 131;
            break;
          }
          _context2.next = 131;
          return nuxt_plugin_idle_82bf8412(app.context, inject);
        case 131:
          if (!(process.client && typeof nuxt_plugin_shortkey_158185f0 === 'function')) {
            _context2.next = 134;
            break;
          }
          _context2.next = 134;
          return nuxt_plugin_shortkey_158185f0(app.context, inject);
        case 134:
          if (!(process.client && typeof nuxt_plugin_vcalendar_1e0c5476 === 'function')) {
            _context2.next = 137;
            break;
          }
          _context2.next = 137;
          return nuxt_plugin_vcalendar_1e0c5476(app.context, inject);
        case 137:
          if (!(process.client && typeof nuxt_plugin_accounts_1a1f19e0 === 'function')) {
            _context2.next = 140;
            break;
          }
          _context2.next = 140;
          return nuxt_plugin_accounts_1a1f19e0(app.context, inject);
        case 140:
          if (!(process.client && typeof nuxt_plugin_imperaviarticle_6a4a25e7 === 'function')) {
            _context2.next = 143;
            break;
          }
          _context2.next = 143;
          return nuxt_plugin_imperaviarticle_6a4a25e7(app.context, inject);
        case 143:
          if (!(process.client && typeof nuxt_plugin_redactor_69963c72 === 'function')) {
            _context2.next = 146;
            break;
          }
          _context2.next = 146;
          return nuxt_plugin_redactor_69963c72(app.context, inject);
        case 146:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 149;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 149:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 150:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };